import React, { useCallback, useMemo } from 'react'
import style from './style.module.scss'
import Breadcrumb from '../../components/Breadcrumb'
import { BreadcrumbItemProps } from '../../components/Breadcrumb'

type PostPageHeaderProps = {
    libelle: string
}

const ErrorPageHeader: React.FC<PostPageHeaderProps> = ({ libelle }) => {
    const links = useMemo(() => {
        let breadcrumb: BreadcrumbItemProps[] = [
            {
                url: '/',
                label: 'Accueil',
            },
            {
                url: null,
                label: libelle,
            },
        ]

        return breadcrumb
    }, [libelle])

    const handleBackClick = useCallback(() => {
        window.history.back()
    }, [])

    return (
        <nav className={style.post}>
            <div className={style.back} onClick={handleBackClick}>
                <i className="fi fi-rs-arrow-small-left" />
                Retour
            </div>

            <Breadcrumb links={links} />
        </nav>
    )
}

export default ErrorPageHeader
